import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getDeviceAreaList, getOpenCloseList } from '@/service/production/proReportAggregate';
export default function useDeviceAreaList(date) {
  var formatDate = function formatDate(date) {
    return dayjs(date).format('YYYY-MM-DD');
  };
  var mainBreakingList = ref({
    name: '',
    id: 0,
    list: []
  });
  var sandMakingList = ref([]);
  // 获取主机汇总数据
  var getDeviceAreaListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getDeviceAreaList({
              isMain: ''
            });
          case 2:
            data = _context.sent;
            data.list.forEach(function (item) {
              if (item.is_main === '1') {
                //主机
                mainBreakingList.value.name = item.area_name;
                mainBreakingList.value.id = item.id;
              } else {
                //砂石骨料
                sandMakingList.value.push({
                  name: item.area_name,
                  id: item.id,
                  list: []
                });
              }
              getOpenCloseListAsync({
                areaId: item.id,
                isMain: item.is_main,
                date: formatDate(new Date(date.value.startTime))
              });
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getDeviceAreaListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  // 查询当天开停机列表
  var getOpenCloseListAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
      var data, target;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log('getOpenCloseListAsync', params);
            _context2.next = 3;
            return getOpenCloseList(params);
          case 3:
            data = _context2.sent;
            if (params.isMain === '1') {
              mainBreakingList.value.list = data.list;
            } else {
              target = sandMakingList.value.find(function (item) {
                return item.id === params.areaId;
              });
              if (target) {
                target.list = data.list;
              }
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getOpenCloseListAsync(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return [mainBreakingList, sandMakingList, getDeviceAreaListAsync];
}